import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
  Typography,
  Tabs,
  Tab,
  Card,
  CardContent,
  Grid,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Select,
  MenuItem,
  Menu,
  FormControl,
  InputLabel,
  TextField,
  Chip,
  Avatar,
  IconButton,
  Tooltip,
  RadioGroup,
  FormControlLabel,
  Radio,
  Checkbox,
  FormGroup,
  Divider,
  OutlinedInput,
  TablePagination,
} from "@mui/material";
import {
  TrendingUp,
  CreditCard,
  Message,
  AccountBalanceWallet,
  Public,
  Receipt,
  Settings,
  Download,
  Add,
  Visibility,
  CalendarToday,
  AttachMoney,
  ArrowUpward,
  Info,
} from "@mui/icons-material";

import SearchIcon from "@mui/icons-material/Search";
import EventIcon from "@mui/icons-material/Event";
import PeopleIcon from "@mui/icons-material/People";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import CheckIcon from "@mui/icons-material/Check";
import MoreVertIcon from "@mui/icons-material/MoreVert";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { GET_INVOICES_ENDPOINT, GET_TENANT_DETAILS, GET_SUBSCRIPTION_INVOICE_SUMMARY } from "../../config/urls";
import { formatDateOnly } from "../../utils/dateUtils";
import TableSearchInput from "../TableSearchInput";
import TableFilterButton from "../TableFilterButton";
import { FilterModal, FilterModalItem } from "../FilterModal";
import { CalendarIcon } from "@mui/x-date-pickers";
import FlagIcon from "@mui/icons-material/Flag";
import CustomTabs from "../../common/custom-tabs";
import BillingHistory from "../SubscriptionManagement/BillingHistory";
import TransactionDetails from "../SubscriptionManagement/TransactionDetails";
import AppTable from "../../common/app-table";
import typography from "../../cssUtils/typography";
import { useBranding } from "../../hooks/brandingProvider";

export default function InvoicesTab() {
  const { favicon_url: faviconUrl } = useBranding() || {};
  const [page, setPage] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [invoices, setInvoices] = useState([]);
  const [billingCurrency, setBillingCurrency] = useState("INR");
  const [currentTab, setCurrentTab] = useState(() => {
    const stored = localStorage.getItem("invoiceDefaultTab");
    return stored !== null ? parseInt(stored, 10) : 0;
  });

  useEffect(() => {
    localStorage.removeItem("invoiceDefaultTab");
    const handler = (e) => setCurrentTab(e.detail.tab);
    window.addEventListener("set-invoice-tab", handler);
    return () => window.removeEventListener("set-invoice-tab", handler);
  }, []);
  const [dateAnchorEl, setDateAnchorEl] = useState(null);
  const [dateRange, setDateRange] = useState([null, null]);

  const [statusAnchorEl, setStatusAnchorEl] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState("");

  const [filterModalOpen, setFilterModalOpen] = useState(false);

  // New filter states
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const [selectedFilterStatus, setSelectedFilterStatus] = useState("");

  const [rowsPerPage, setRowsPerPage] = useState(20);

  // State for subscription invoice summary
  const [subscriptionSummary, setSubscriptionSummary] = useState({
    total_revenue: 0,
    invoice_count: 0
  });

  // Action menu (3-dot) state
  const [actionMenuAnchor, setActionMenuAnchor] = useState(null);
  const [actionMenuRow, setActionMenuRow] = useState(null);

  // Function to get currency symbol
  const getCurrencySymbol = (currencyCode) => {
    switch (currencyCode?.toUpperCase()) {
      case "USD":
        return "$";
      case "EUR":
        return "€";
      case "GBP":
        return "£";
      case "INR":
        return "₹";
      case "AED":
        return "د.إ";
      default:
        return "₹";
    }
  };

  // Simple format for display without full currency formatting
  const formatCurrencySimple = (value) => {
    const currencySymbol = getCurrencySymbol(billingCurrency);
    return `${currencySymbol}${
      value
        ? parseFloat(value).toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 3,
          })
        : "0.00"
    }`;
  };

  // Fetch tenant details to get billing currency
  const fetchTenantDetails = async () => {
    try {
      const tenant = localStorage.getItem("tenant");
      const response = await fetch(GET_TENANT_DETAILS, {
        headers: {
          "Content-Type": "application/json",
          "X-Tenant-ID": tenant,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Tenant Details:", data);

      if (
        data.results &&
        data.results.length > 0 &&
        data.results[0].billing_currency
      ) {
        setBillingCurrency(data.results[0].billing_currency);
      }
    } catch (error) {
      console.error("Error fetching tenant details:", error);
    }
  };

  // Fetch subscription invoice summary
  const fetchSubscriptionSummary = async () => {
    try {
      const tenant = localStorage.getItem("tenant");
      const response = await fetch(GET_SUBSCRIPTION_INVOICE_SUMMARY, {
        headers: {
          "Content-Type": "application/json",
          "X-Tenant-ID": tenant,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch subscription summary");
      }

      const data = await response.json();
      setSubscriptionSummary({
        total_revenue: data.total_revenue || 0,
        invoice_count: data.invoice_count || 0
      });
    } catch (error) {
      console.error("Error fetching subscription summary:", error);
    }
  };

  useEffect(() => {
    const tenant = localStorage.getItem("tenant");
    fetch(`${GET_INVOICES_ENDPOINT}`, {
      headers: {
        "Content-Type": "application/json",
        "X-Tenant-ID": tenant,
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch invoices");
        return res.json();
      })
      .then((data) => setInvoices(data))
      .catch((error) => console.error("Fetch error:", error));

    fetchTenantDetails();
    fetchSubscriptionSummary();
  }, []);

  console.log("Invoices:", invoices);

  useEffect(() => {
    setPage(0);
  }, [
    searchTerm,
    dateRange,
    selectedStatus,
    selectedMonth,
    selectedType,
    selectedFilterStatus,
  ]);

  // Download Invoice Function
  const downloadInvoice = (invoiceId, invoiceNumber) => {
    const tenantId = localStorage.getItem("tenant");
    const faviconPath = `${window.location.origin}/api/whitelabeling/favicons/botbridge.ico`;

    fetch(`${GET_INVOICES_ENDPOINT}${invoiceId}/generate-pdf/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/pdf",
        "X-Tenant-ID": tenantId,
      },
    })
      .then((response) => response.blob())
      .then((blob) => {
        // ✅ Convert PDF blob to base64 data URL
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64PDF = reader.result;
          
          // ✅ Fetch favicon and convert to base64 for embedding
          fetch(faviconPath)
            .then(res => res.blob())
            .then(faviconBlob => {
              const faviconReader = new FileReader();
              faviconReader.onloadend = () => {
                const base64Favicon = faviconReader.result;
                
                // ✅ Create HTML wrapper with embedded favicon (base64) and PDF
                const htmlContent = `
                <!DOCTYPE html>
                <html lang="en">
                <head>
                    <meta charset="utf-8" />
                    <link rel="icon" href="${base64Favicon}" />
                    <meta name="viewport" content="width=device-width, initial-scale=1" />
                    <meta name="theme-color" content="#000000" />
                    <title>Invoice ${invoiceNumber}</title>
                    <style>
                        * { margin: 0; padding: 0; box-sizing: border-box; }
                        body { background-color: #f5f5f5; font-family: Arial, sans-serif; }
                        .container { width: 100%; height: 100vh; display: flex; align-items: center; justify-content: center; }
                        embed, object { width: 100%; height: 100%; }
                        @media (max-width: 768px) {
                            .container { padding: 10px; }
                        }
                    </style>
                </head>
                <body>
                    <div class="container">
                        <embed src="${base64PDF}" type="application/pdf" />
                    </div>
                </body>
                </html>
                `;
                
                const htmlBlob = new Blob([htmlContent], { type: 'text/html' });
                const htmlUrl = window.URL.createObjectURL(htmlBlob);
                const link = document.createElement("a");
                link.href = htmlUrl;
                link.download = `${invoiceNumber}.html`;
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(htmlUrl);
              };
              faviconReader.readAsDataURL(faviconBlob);
            })
            .catch(err => {
              console.warn("Failed to fetch favicon, proceeding without embedded favicon:", err);
              // Fallback: proceed without favicon if fetch fails
              const htmlContent = `
              <!DOCTYPE html>
              <html lang="en">
              <head>
                  <meta charset="utf-8" />
                  <meta name="viewport" content="width=device-width, initial-scale=1" />
                  <meta name="theme-color" content="#000000" />
                  <title>Invoice ${invoiceNumber}</title>
                  <style>
                      * { margin: 0; padding: 0; box-sizing: border-box; }
                      body { background-color: #f5f5f5; font-family: Arial, sans-serif; }
                      .container { width: 100%; height: 100vh; display: flex; align-items: center; justify-content: center; }
                      embed, object { width: 100%; height: 100%; }
                      @media (max-width: 768px) {
                          .container { padding: 10px; }
                      }
                  </style>
              </head>
              <body>
                  <div class="container">
                      <embed src="${base64PDF}" type="application/pdf" />
                  </div>
              </body>
              </html>
              `;
              const htmlBlob = new Blob([htmlContent], { type: 'text/html' });
              const htmlUrl = window.URL.createObjectURL(htmlBlob);
              const link = document.createElement("a");
              link.href = htmlUrl;
              link.download = `${invoiceNumber}.html`;
              document.body.appendChild(link);
              link.click();
              link.remove();
              window.URL.revokeObjectURL(htmlUrl);
            });
        };
        reader.readAsDataURL(blob);
      })
      .catch((error) => {
        console.error("Error downloading the invoice:", error);
      });
  };

  const previewInvoice = (invoiceId, invoiceNumber) => {
    const tenant = localStorage.getItem("tenant");

    fetch(`${GET_INVOICES_ENDPOINT}${invoiceId}/generate-pdf/`, {
      method: "GET",
      headers: {
        "X-Tenant-ID": tenant,
      },
    })
      .then((response) => response.blob())
      .then((blob) => {
        // ✅ Convert PDF blob to base64 data URL
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64PDF = reader.result; // This is a data URL like: data:application/pdf;base64,...
          const faviconLink = faviconUrl
            ? `<link rel="icon" href="${faviconUrl}" /><link rel="shortcut icon" href="${faviconUrl}" />`
            : '';

          // ✅ Create HTML wrapper with favicon and embedded PDF
          const htmlContent = `
          <!DOCTYPE html>
          <html lang="en">
          <head>
              <meta charset="utf-8" />
              ${faviconLink}
              <meta name="viewport" content="width=device-width, initial-scale=1" />
              <meta name="theme-color" content="#000000" />
              <title>Invoice ${invoiceNumber}</title>
              <style>
                  * { margin: 0; padding: 0; box-sizing: border-box; }
                  body { background-color: #f5f5f5; font-family: Arial, sans-serif; }
                  .container { width: 100%; height: 100vh; display: flex; align-items: center; justify-content: center; }
                  embed, object { width: 100%; height: 100%; }
                  @media (max-width: 768px) {
                      .container { padding: 10px; }
                  }
              </style>
          </head>
          <body>
              <div class="container">
                  <embed src="${base64PDF}" type="application/pdf" />
              </div>
          </body>
          </html>
          `;
          
          // ✅ Create HTML blob and open it
          const htmlBlob = new Blob([htmlContent], { type: 'text/html' });
          const htmlUrl = URL.createObjectURL(htmlBlob);
          window.open(htmlUrl, "_blank");
        };
        reader.readAsDataURL(blob);
      })
      .catch((error) => {
        console.error("Error previewing the invoice:", error);
      });
  };

  const invoiceArray = invoices.results || [];

  // Generate month options dynamically from invoice data
  const getMonthOptions = () => {
    const months = new Set();
    invoiceArray.forEach((invoice) => {
      if (invoice.billing_month && invoice.billing_year) {
        const monthKey = `${invoice.billing_month}-${invoice.billing_year}`;
        const monthLabel = `${dayjs()
          .month(invoice.billing_month - 1)
          .format("MMMM")} ${invoice.billing_year}`;
        months.add(JSON.stringify({ key: monthKey, label: monthLabel }));
      }
    });
    return Array.from(months)
      .map((item) => JSON.parse(item))
      .sort((a, b) => {
        const [monthA, yearA] = a.key.split("-").map(Number);
        const [monthB, yearB] = b.key.split("-").map(Number);
        return yearB - yearA || monthB - monthA;
      });
  };

  const filteredRows = invoiceArray.filter((row) => {
    const invoiceDate = dayjs(row.invoice_date);
    const invoiceNumber = (row.invoice_number || "").toLowerCase();
    const clientName = (row.client_details?.name || "").toLowerCase();
    const searchTermLC = searchTerm.toLowerCase();

    const matchesSearch =
      invoiceNumber.includes(searchTermLC) || clientName.includes(searchTermLC);

    const matchesDateRange =
      !dateRange[0] ||
      !dateRange[1] ||
      (invoiceDate.isAfter(dateRange[0].startOf("day").subtract(1, "minute")) &&
        invoiceDate.isBefore(dateRange[1].endOf("day").add(1, "minute")));

    const matchesStatus =
      !selectedStatus ||
      row.status?.toLowerCase() === selectedStatus.toLowerCase();

    const matchesMonth =
      !selectedMonth ||
      `${row.billing_month}-${row.billing_year}` === selectedMonth;

    const matchesType =
      !selectedType || row.type?.toLowerCase() === selectedType.toLowerCase();

    const matchesFilterStatus =
      !selectedFilterStatus ||
      row.status?.toLowerCase() === selectedFilterStatus.toLowerCase();

    return (
      matchesSearch &&
      matchesDateRange &&
      matchesStatus &&
      matchesMonth &&
      matchesType &&
      matchesFilterStatus
    );
  });

  // Sort by issue date in descending order (newest first)
  const sortedRows = [...filteredRows].sort(
    (a, b) => dayjs(b.invoice_date).valueOf() - dayjs(a.invoice_date).valueOf(),
  );


  const handleResetFilters = () => {
    setSearchTerm("");
    setDateRange([null, null]);
    setSelectedStatus("");
    setSelectedMonth("");
    setSelectedType("");
    setSelectedFilterStatus("");
  };

  const getTotalActiveFilters = () => {
    let count = 0;
    if (dateRange[0]) count++;
    if (dateRange[1]) count++;
    if (selectedStatus) count++;
    if (selectedMonth) count++;
    if (selectedType) count++;
    if (selectedFilterStatus) count++;
    return count;
  };

  // Current year
  const currentYear = dayjs().year();

  // Paid invoices of this year
  const allTimePaid = invoiceArray
    .filter((inv) => inv.status?.toLowerCase() === "paid")
    .reduce((sum, inv) => sum + Number(inv.total_amount || 0), 0);

  const allTimeBill = invoiceArray.reduce(
    (sum, inv) => sum + Number(inv.total_amount || 0),
    0,
  );

  // Outstanding (pending/overdue)
  const outstanding = invoiceArray
    .filter((inv) => inv.status?.toLowerCase() !== "paid")
    .reduce((sum, inv) => sum + Number(inv.total_amount || 0), 0);

  // Average Monthly (divide paid this year by current month index)
  let averageMonthly = 0;
  try {
    if (invoices.count && allTimeBill) {
      averageMonthly = allTimeBill / invoices.count;
    }
  } catch (e) {
    console.error("Error calculating averageMonthly:", e);
    averageMonthly = 0;
  }

  const tabs = [
    {
      label: "Monthly Usage Invoice",
      value: 0,
    },
    {
      label: "Subscription Invoice",
      value: 1,
    },
  ];
  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  const isActionMenuOpen = Boolean(actionMenuAnchor);

  const closeActionMenu = () => {
    setActionMenuAnchor(null);
    setActionMenuRow(null);
  };

  const messageTableColumns = [
    {
      id: "invoice_number",
      label: "Invoice ID",
      render: (row) => <Typography fontWeight={600}>{row.invoice_number}</Typography>,
    },
    {
      id: "billing_month",
      label: "Month",
      render: (row) =>
        dayjs().month(row.billing_month - 1).format("MMM") + " " + row.billing_year.toString(),
    },
    {
      id: "invoice_date",
      label: "Issue Date",
      render: (row) => formatDateOnly(row.invoice_date),
    },
    {
      id: "due_date",
      label: "Due Date",
      render: (row) => formatDateOnly(row.due_date),
    },
    {
      id: "payment_date",
      label: "Payment Date",
      render: (row) =>
        row.payment_date ? formatDateOnly(row.payment_date) : "N/A",
    },
    {
      id: "total_amount",
      label: "Amount",
      render: (row) => formatCurrencySimple(Number(row.total_amount)),
    },
    {
      id: "balance_due",
      label: "Balance Due",
      render: (row) => formatCurrencySimple(Number(row.balance_due)),
    },
    {
      id: "status",
      label: "Status",
      render: (row) => (
        <Chip
          label={row.status_display || row.status}
          color={
            row.status?.toLowerCase() === "paid"
              ? "success"
              : row.status?.toLowerCase() === "overdue"
              ? "error"
              : "warning"
          }
          size="small"
        />
      ),
    },
    {
      id: "__actions__",
      label: "Actions",
      align: "center",
      render: (row) => (
        <Box onClick={(e) => e.stopPropagation()}>
          <IconButton
            onClick={(e) => {
              setActionMenuAnchor(e.currentTarget);
              setActionMenuRow(row);
            }}
            disableRipple
            sx={{
              p: 0.5,
              color: "#111827",
              backgroundColor: "transparent",
              "&:hover": { backgroundColor: "transparent", color: "#111827" },
            }}
          >
            <MoreVertIcon sx={{ fontSize: 18 }} />
          </IconButton>
        </Box>
      ),
    },
  ];

  return (
    <Box sx={{ pt: 5, px: 3, pb: 2,  backgroundColor: "#F7F7F7" }}>
      <Box sx={{ mb: 2 }}>
        <CustomTabs
          value={currentTab}
          onChange={handleTabChange}
          tabs={tabs}
          inactiveBgColor="#E8EAED"
          backgroundColor="#E8EAED"
        />
      </Box>
      {currentTab === 1 && (
        <>
        
          <BillingHistory billingCurrency={billingCurrency} />
          <Grid container spacing={3} sx={{ mt: 3 }}>
            <Grid item xs={12} md={6}>
              <Card>
                <CardContent>
                  <Typography sx={{ ...typography.h1 }} gutterBottom>
                    Subscription Invoice Summary
                  </Typography>
                  <Box
                    sx={{ display: "flex", flexDirection: "column", gap: 2 }}
                  >
                    <Box
                      sx={{ display: "flex", justifyContent: "space-between" }}
                    >
                      <Typography sx={{ ...typography.h2 ,color: "#505050"}}>
                        Total Invoices
                      </Typography>
                      <Typography sx={{ ...typography.h2 }}>
                        {subscriptionSummary.invoice_count}
                      </Typography>
                    </Box>
                    <Box
                      sx={{ display: "flex", justifyContent: "space-between" }}
                    >
                      <Typography sx={{ ...typography.h2 ,color: "#505050"}}>
                        All Time Paid
                      </Typography>
                      <Typography sx={{ ...typography.h2 }}>
                        {formatCurrencySimple(subscriptionSummary.total_revenue)}
                      </Typography>
                    </Box>
                    <Divider />
                    <Box
                      sx={{ display: "flex", justifyContent: "space-between" }}
                    >
                      <Typography sx={{ ...typography.h2 ,color: "#000000DE"}}>
                        Average Invoice Value
                      </Typography>
                      <Typography sx={{ ...typography.h1}}>
                        {formatCurrencySimple(
                          subscriptionSummary.invoice_count > 0 
                            ? subscriptionSummary.total_revenue / subscriptionSummary.invoice_count 
                            : 0
                        )}
                      </Typography>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
          <Box sx={{ mt: 3 }}>
            <TransactionDetails billingCurrency={billingCurrency} />
          </Box>
        </>
      )}

      {/* Invoice Summary and Billing Settings for Monthly Usage Invoice */}
       {currentTab === 0 && (
        <>
          <Card>
            <CardContent>
              <AppTable
                columns={messageTableColumns}
                rows={filteredRows}
                rowKey="id"
                emptyMessage="No invoices found matching your filters"
                paperSx={{ border: "1px solid rgba(0,0,0,0.12)", boxShadow: "none" }}
                stickyHeader={false}
                hideMainScroll={false}
                count={filteredRows.length}
                page={page}
                rowsPerPage={rowsPerPage}
                rowsPerPageOptions={[20, 50, 100]}
                onPageChange={(_, newPage) => setPage(newPage)}
                onRowsPerPageChange={(e) => {
                  setRowsPerPage(parseInt(e.target.value, 10));
                  setPage(0);
                }}
              />
            </CardContent>
          </Card>

          <Grid container spacing={3} sx={{ mt: 3 }}>
            <Grid item xs={12} md={6}>
              <Card>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    Invoice Summary
                  </Typography>
                  <Box
                    sx={{ display: "flex", flexDirection: "column", gap: 2 }}
                  >
                    <Box
                      sx={{ display: "flex", justifyContent: "space-between" }}
                    >
                      <Typography color="text.secondary">
                        Total Invoices
                      </Typography>
                      <Typography fontWeight="medium">
                        {invoices.count}
                      </Typography>
                    </Box>
                    <Box
                      sx={{ display: "flex", justifyContent: "space-between" }}
                    >
                      <Typography color="text.secondary">
                        All Time Paid
                      </Typography>
                      <Typography fontWeight="medium">
                        {formatCurrencySimple(allTimePaid)}
                      </Typography>
                    </Box>
                    <Box
                      sx={{ display: "flex", justifyContent: "space-between" }}
                    >
                      <Typography color="text.secondary">
                        Outstanding
                      </Typography>
                      <Typography fontWeight="medium" color="warning.main">
                        {formatCurrencySimple(outstanding)}
                      </Typography>
                    </Box>
                    <Divider />
                    <Box
                      sx={{ display: "flex", justifyContent: "space-between" }}
                    >
                      <Typography fontWeight="medium">
                        Average Monthly
                      </Typography>
                      <Typography fontWeight="bold" variant="h6">
                        {formatCurrencySimple(averageMonthly)}
                      </Typography>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </>
      )}

      {/* 3-dot actions menu for invoice rows */}
<Menu
  anchorEl={actionMenuAnchor}
  open={isActionMenuOpen}
  onClose={closeActionMenu}
  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
  transformOrigin={{ vertical: "top", horizontal: "right" }}
  PaperProps={{
    elevation: 0,
    sx: {
      border: "1px solid #DCDFE5",
      borderRadius: "8px",
      backgroundColor: "#FFFFFF",
      p: 0.25,
      "& .MuiList-root": { p: 0 },
    },
  }}
>
  <Box sx={{ display: "flex", flexDirection: "column", gap: 0, px: 0.5 }}>
    <Tooltip title="Preview" placement="top" arrow>
      <span>
        <IconButton
          size="small"
          onClick={() => {
            if (actionMenuRow) previewInvoice(actionMenuRow.id, actionMenuRow.invoice_number);
            closeActionMenu();
          }}
          sx={{
            color: "#111827",
            backgroundColor: "#FFFFFF",
            transition: "background-color 0.2s ease, color 0.2s ease",
            "&:hover": { backgroundColor: "#F0F2F8", color: "#111827" },
          }}
        >
          <VisibilityIcon sx={{ fontSize: 18 }} />
        </IconButton>
      </span>
    </Tooltip>
    <Tooltip title="Download" placement="top" arrow>
      <span>
        <IconButton
          size="small"
          onClick={() => {
            if (actionMenuRow) downloadInvoice(actionMenuRow.id, actionMenuRow.invoice_number);
            closeActionMenu();
          }}
          sx={{
            color: "#111827",
            backgroundColor: "#FFFFFF",
            transition: "background-color 0.2s ease, color 0.2s ease",
            "&:hover": { backgroundColor: "#F0F2F8", color: "#111827" },
          }}
        >
          <Download sx={{ fontSize: 18 }} />
        </IconButton>
      </span>
    </Tooltip>
  </Box>
</Menu>
    </Box>
  );
}